import {DangerButton} from "./CustomButton";
import EmptyState from "./EmptyState";
import {CustomSpinner} from "./CustomSpinner";
import React from "react";

function TableItemLoader({
                           loading = false,
                           error = '',
                           isEmpty = false,
                           retry,
                           count = 2,
                           keyName = '',
                           loaderItemHeight,
                           loaderItemWidth,
                           isCircular = false,
                           isTableFilter = false,
                           emptyStateMessage,
                           emptyStateHasBackground = false,
                           emptyStateIcon,
                           children
                         }) {
  const getShimmerByCount = () => {
    return Array.from({length: count}, (_, i) =>
      <div key={`${keyName}-${i}`}
           className={`${loaderItemHeight ? loaderItemHeight : "h-[82px]"} ${loaderItemWidth ? loaderItemWidth : "w-full"} animate-pulse bg-gray-200 rounded-md w-full mb-2.5`}/>,
    )
  }
  return (
    (error.length > 0) ?
      <div className='flex justify-center items-center'>
        <div className='space-y-4 text-center'>
          <p className='text-red-500'>{error ?? 'Error loading data.'}</p>
          <DangerButton onClick={retry}>Retry</DangerButton>
        </div>
      </div> :
      (isEmpty && !loading) ?
        <EmptyState message={emptyStateMessage ?? "No records to display."} hasBackground={emptyStateHasBackground} icon={emptyStateIcon}/>
        : children ? children : (isCircular ?
          <div className={`w-full ${loaderItemHeight ? loaderItemHeight : "h-52"} flex justify-center items-center`}>
            <CustomSpinner/>
          </div> :
          isTableFilter ? <div className="flex justify-between mb-2">
              <div className="bg-gray-200 w-60 h-[38px] app-rounded"></div>
              <div className="bg-gray-200 w-60 h-[38px] app-rounded"></div>
            </div> :
            <>
              <div className="h-[60px]"></div>
              {/*<tr><td colSpan="5" ></td></tr>*/}
              {getShimmerByCount()}
            </>)
  )
}

export default TableItemLoader